import React from 'react';
import { ConfirmDialog } from 'swag-client-common/components/info/confirm-dialog';
import css from './delete-art-folder-logo-popup.scss';
export function DeleteArtFolderLogoPopupComponent({
  open,
  logoId,
  isCompanyOrdersAvailable,
  showDeleteForCompanyFlow,
  msgText,
  cancelText,
  confirmText,
  deleteLogo,
  cancelDelete
}) {
  const handleConfirm = () => {
    if (!isCompanyOrdersAvailable) {
      return deleteLogo({
        id: logoId,
        shouldDeleteForEverybody: true
      });
    }
    deleteLogo({
      id: logoId
    });
  };
  const handleCancel = () => {
    if (showDeleteForCompanyFlow) {
      return deleteLogo({
        id: logoId,
        shouldDeleteForEverybody: true
      });
    }
    return cancelDelete();
  };
  return /*#__PURE__*/React.createElement(ConfirmDialog, {
    open: open,
    cancelText: cancelText,
    onConfirm: handleConfirm,
    onCancel: handleCancel,
    onClose: cancelDelete,
    confirmText: confirmText,
    rootContentClassName: css.content,
    buttonConfirmClassName: css.button,
    buttonCancelClassName: css.button,
    msg: msgText,
    title: "Hey, you're about to delete artwork from your company art folder!",
    isResponsive: true
  });
}